import request from '@/utils/request'
const BASE_URL = '/StProductStock'

//系统
export default {
  list(data) {
    return request({
      url: BASE_URL + '/GoodsStockSum',
      method: 'post',
      data
    })
  },
  inOutList(data) {
    return request({
      url: BASE_URL + '/InOutList',
      method: 'post',
      data
    })
  },
  existQuantity(data){
    return request({
      url: BASE_URL + '/ExistQuantity',
      method: 'post',
      data
    })
  },
  changeExistQuantity(){
    return request({
      url: BASE_URL + '/ChangeExistQuantity',
      method: 'post',
    })
  },
}